import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";
import Text from "../ui/Text";


export default class CharacterSelectScene extends Scene {
    constructor()
    {
        super('CharacterSelectScene');

        this.characterData = null;
        this.spines = null;
        this.spineHolder = null;
        this.currentSpine = null;
        this.nextSpine = null;
        this.spineTweenIn = null;
        this.spineTweenOut = null;
        this.paginations = null;

        this.charName = null;
        this.statBoard = null;
        this.statBackNote = null;
        this.statNote = null;
        this.statBars = null;

        this.currentCharacter = 0;

        this.statsPanel = null;

        this.swipeOrigin = null;
        this.swipeCurrent = null;

        this.statDivision = 5;
        this.statBarWidth = 125;
    }

    init()
    {
        super.init('bg');

        //var titleText = new Text(common.text.translate('chooseCharacter'), {
        var titleText = new Text(common.text.translate('chooseCharacter'), {
            font: 60 + "px Lalezar56",
            align: "center"/*,
            tint: 0x000000*/
        });
        titleText.x = common.STAGE_HALF_WIDTH;
        titleText.y = 20;
        titleText.anchor.x = 0.5;
        this.addChild(titleText);

        this.characterData = [];
        this.spines = [];
        this.paginations = [];

        var paginationHolder = common.display.container({y:common.STAGE_HEIGHT-50});

        console.log('character', common.character);

        var count = 0;
        for(var i in common.config.characters)
        {
            if(common.config.characters[i].playable)
            {
                if(common.character == i)
                    this.currentCharacter = count;

                this.characterData.push(common.config.characters[i]);
                var thisSpineHolder = common.display.container();
                common.display.sprite({asset:'food_shadow', anchorX:0.5, anchorY:0.4, scaleX:4, scaleY:0.6, parent:thisSpineHolder});

                var spineData = P3.assets.spineData(common.config.characters[i].spine + '_big');
                var spine = new PIXI.spine.Spine(spineData);
                spine.id = i;
                spine.scale.set(-0.85, 0.85);
                thisSpineHolder.addChild(spine);
                thisSpineHolder.spine = spine;

                spine.skeleton.setSlotsToSetupPose();
                spine.skeleton.setToSetupPose();
                spine.autoUpdate = false;

                spine.state.setAnimation(0, 'char_idle_menu', true);

                spine.stateData.setMix('char_idle_menu', 'body_idle_victory', 0.2);
                spine.stateData.setMix('char_idle_menu', 'legs_idle_victory', 0.2);

                var pagination = common.display.sprite({asset:'pagination_off', x:paginationHolder.width + 5, parent:paginationHolder});
                this.paginations.push(pagination);

                this.spines.push(thisSpineHolder);
                count++;
            }
        }

        this.spineHolder = common.display.container({parent:this, x:common.STAGE_HALF_WIDTH + 200, y:common.STAGE_HEIGHT - 40});
        this.currentSpine = this.spines[this.currentCharacter];
        this.spineHolder.addChild(this.currentSpine);

        this.addChild(paginationHolder);
        paginationHolder.x = common.STAGE_HALF_WIDTH - (paginationHolder.width/2);

        this.statBoard = common.display.sprite({asset:'stats_board_asset', anchor:0.5, y:common.STAGE_HALF_HEIGHT, x:common.STAGE_HALF_WIDTH-200, parent:this});

        this.statBackNote = common.display.sprite({asset:'paper_sheet_asset', degrees:-5+(Math.random()*10), anchorX:0.5, anchorY:0.07, y:-150, parent:this.statBoard});
        this.statNote = common.display.sprite({asset:'paper_sheet_asset', degrees:-5+(Math.random()*10), anchorX:0.5, anchorY:0.07, y:-150, parent:this.statBoard});
        this.statNote.pin = common.display.sprite({asset:'pin_asset', anchor:0.5, parent:this.statNote});
        this.statNote.charLogo = common.display.sprite({anchor:1, x:(this.statNote.width/2)-13, y:this.statNote.height-50, parent:this.statNote})

        var stats = ["speed", "range", "power", "stamina"];

        this.statBars = {};
        var currentY = 30;
        for(var i in stats)
        {
            var stat = common.display.container({parent:this.statNote, x:-76, y:currentY});

            common.display.sprite({asset:stats[i] + '_icon', x:-5, anchorX:1, parent:stat});

            var text = new Text(common.text.translate(stats[i]), {
                font: 18 + "px Pangolin",
                align: "center"
            });
            text.anchor.set(0, 0);
            stat.addChild(text);

            var bar = common.display.sprite({asset:'panel_stats', y:text.y + text.height + 10, parent:stat})
            //var bar = common.display.rectangle({rectWidth:200, rectHeight:25, y:text.y + text.height + 10, fillColour:0x000000, parent:stat});
            //this.statBars[stats[i]] = common.display.rectangle({rectWidth:bar.width, rectHeight:bar.height, y:bar.y, fillColour:0xf0120e, parent:stat});

            var fill = new PIXI.mesh.NineSlicePlane(P3.assets.texture('stats_bar'), 10, 0, 10, 0);
            fill.width = this.statBarWidth;
            fill.x = bar.x + 10;
            fill.y = bar.y + 5;
            stat.addChild(fill);
            this.statBars[stats[i]] = fill;

            for(var j = 1; j < this.statDivision; j++)
            {
                common.display.sprite({asset:'stats_bar_divider', x:fill.x + ((fill.width/this.statDivision) * j), y:fill.y, anchorX:0.5, parent:stat});
            }

            currentY += stat.height + 10;
        }

        this.charName = new Text(common.text.translate(this.characterData[this.currentCharacter].name), {
            font: 50 + "px Lalezar48",
            align: "center"
        });
        this.charName.y = -240;
        this.charName.anchor.set(0.5);
        this.statBoard.addChild(this.charName);

        this.setCharacter();

        this.buttons.left = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_secondary_medium_previous_out'),
            P3.assets.texture('btn_secondary_medium_previous_over'),
            P3.assets.texture('btn_secondary_medium_previous_down'),
            PIXI.Texture.EMPTY
        ));
        this.buttons.left.id = 'left';
        this.buttons.left.y = common.STAGE_HALF_HEIGHT;
        this.signalListeners.push(this.buttons.left.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.left);

        this.buttons.right = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_secondary_medium_next_out'),
            P3.assets.texture('btn_secondary_medium_next_over'),
            P3.assets.texture('btn_secondary_medium_next_down'),
            PIXI.Texture.EMPTY
        ));
        this.buttons.right.id = 'right';
        this.buttons.right.y = common.STAGE_HALF_HEIGHT;
        this.signalListeners.push(this.buttons.right.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.right);

        this.buttons.play = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.play.id = 'play';
        this.buttons.play.icon.anchor.set(0.45, 0.53);
        this.buttons.play.y = common.STAGE_HEIGHT - 120;
        this.signalListeners.push(this.buttons.play.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.play);

        this.signalListeners.push(
            P3.input.signals.keyUp.add(this.onKeyUp, this),
            P3.input.signals.mouseMove.add(this.onMouseMove, this),
            P3.input.signals.mouseDown.add(this.onMouseDown, this),
            P3.input.signals.mouseUp.add(this.onMouseUp, this)
            //P3.input.signals.swipeLeft.add(this.moveRight, this),
            //P3.input.signals.swipeRight.add(this.moveLeft, this)
        );

        this.addHomeButton();

        common.audio.playSound('music_choose_character_loop', this.audioLoopParams);
    }

    destroy()
    {
        if(common.config.characters.unknown)
        {
            common.config.characters.unknown.spine = common.config.characters[common.character].spine;
        }

        common.audio.stopSound('music_choose_character_loop');
        super.destroy();
    }

    update()
    {
        super.update();

        for(var i in this.spines)
        {
            this.spines[i].spine.update(P3.Ticker.dt * common.timeStretch);
        }
    }

    resize()
    {
        super.resize();

        this.buttons.left.x = (common.STAGE_HALF_WIDTH - (P3.View.width / 2)) + 50;
        this.buttons.right.x = (common.STAGE_HALF_WIDTH + (P3.View.width / 2)) - 50;
        this.buttons.play.x = (common.STAGE_HALF_WIDTH + (P3.View.width / 2)) - 120;
    }

    setCharacter()
    {
        this.charName.text = common.text.translate(this.characterData[this.currentCharacter].name);
        
        var colours = ['stats_bar5', 'stats_bar4', 'stats_bar3', 'stats_bar2', 'stats_bar1'];

        for(var i in this.statBars)
        {
            var value = Math.round(this.characterData[this.currentCharacter][i] * this.statDivision) / this.statDivision;
            this.statBars[i].width = Math.min(this.statBarWidth, (value * this.statBarWidth) + 3);
            this.statBars[i].texture = P3.assets.texture(colours[(value*colours.length)-1]);
        }

        this.statNote.charLogo.texture = P3.assets.texture(this.spines[this.currentCharacter].spine.id + '_icon');
        
        for(var i in this.paginations)
        {
            this.paginations[i].texture = P3.assets.texture('pagination_off');
        }
        this.paginations[this.currentCharacter].texture = P3.assets.texture('pagination_on');
    }

    moveLeft()
    {
        if(!this.checkExistingMove())
        {
            this.currentCharacter--;
            if(this.currentCharacter < 0)
                this.currentCharacter = this.spines.length-1;
            
            this.startMove(-1);
        }
    }

    moveRight()
    {
        if(!this.checkExistingMove())
        {
            this.currentCharacter++;
            if(this.currentCharacter >= this.spines.length)
                this.currentCharacter = 0;
           
            this.startMove(1);
        }
    }

    checkExistingMove()
    {
        if(this.spineTweenIn && this.spineTweenIn.progress() < 1)
        {
            this.spineTweenIn.kill();
            this.spineTweenOut.kill();
            this.spineTweenIn = null;
            this.spineTweenOut = null;
            this.completeMove();
            return true;
        }
        return false;
    }

    startMove(direction)
    {
        this.setCharacter();

        common.audio.playSound(['sfx_throw_heavy_00', 'sfx_throw_light_00', 'sfx_throw_light_01', 'sfx_throw_light_02', 'sfx_throw_mid_00', 'sfx_throw_v_light_00', 'sfx_throw_v_light_01']);

        this.nextSpine = this.spines[this.currentCharacter];
        this.spineHolder.addChild(this.nextSpine);
        
        this.nextSpine.x = common.STAGE_WIDTH * direction;
        this.spineTweenIn = TweenMax.to(this.nextSpine, .5, {x:0, ease:Expo.easeInOut});
        this.currentSpine.x = 0;
        this.spineTweenOut = TweenMax.to(this.currentSpine, .5, {x:common.STAGE_WIDTH * -direction, ease:Expo.easeInOut, onComplete:this.completeMove.bind(this)});
        
        this.statBackNote.rotation = this.statNote.rotation;

        TweenMax.killTweensOf(this.statNote.scale);
        TweenMax.killTweensOf(this.statNote.anchor);
        TweenMax.killTweensOf(this.statNote.pin.anchor);
        this.statNote.scale.set(1.5);
        this.statNote.y = -100;
        this.statNote.rotation = (-5 + (10 * Math.random())) * PIXI.DEG_TO_RAD;
        this.statNote.pin.anchor.y = 1.5;
        TweenMax.to(this.statNote.scale, .5, {x:1, y:1, ease:Expo.easeOut});
        TweenMax.to(this.statNote, .5, {y:-150, ease:Expo.easeOut});
        TweenMax.to(this.statNote.pin.anchor, .5, {y:0.5, ease:Expo.easeOut});
    }

    completeMove()
    {
        this.spineHolder.removeChild(this.currentSpine);
        this.currentSpine = this.nextSpine;
        this.currentSpine.x = 0;
        this.spineTweenIn = null;
        this.spineTweenOut = null;
    }

    onButtonClicked(button)
    {
        if(button.id === 'play')
        {
            for(var i in this.buttons)
            {
                this.buttons[i].disappear(0.2);
            }
            this.spines[this.currentCharacter].spine.state.setAnimation(0, 'body_idle_victory', true);
            this.spines[this.currentCharacter].spine.state.setAnimation(1, 'legs_idle_victory', true);

            var animsCount = 3;

            this.spines[this.currentCharacter].spine.state.addListener({
                complete: (entry) =>
                { 
                    var anim = entry.animation.name;
                    if(anim === 'body_idle_victory' && animsCount > 0)
                    {
                        animsCount--;
                        if(animsCount == 0)
                        {
                            this.signals.next.dispatch(this.spines[this.currentCharacter].spine.id);
                        }
                    }
                }
            });

            
        }
        else if(button.id == 'left')
        {
            this.moveLeft();
        }
        else if(button.id == 'right')
        {
            this.moveRight();
        }
    }

    onKeyUp(event)
    {
        switch (event.keyCode) {
            case P3.keys.LEFT:
                this.moveLeft();
            break;
            case P3.keys.RIGHT:
                this.moveRight();
            break;
        }
    }

    onMouseMove(e)
    {
        var pos = e.data.getLocalPosition(this);
        this.swipeCurrent = pos.x;
    }

    onMouseDown(e)
    {
        var pos = e.data.getLocalPosition(this);
        var margin = 400;
        if(pos.x > common.STAGE_HALF_WIDTH - margin && pos.x < common.STAGE_HALF_WIDTH + margin &&
           pos.y < common.STAGE_HEIGHT - 230)
        {
            this.swipeOrigin = pos.x;
        }
    }

    onMouseUp(e)
    {
        if(this.swipeOrigin != null && this.swipeCurrent != null)
        {
            if(this.swipeCurrent < this.swipeOrigin) this.moveRight();
            if(this.swipeCurrent > this.swipeOrigin) this.moveLeft();
        }
        this.swipeOrigin = null;
        this.swipeCurrent = null;
    }
}